import { render } from "./DataTableComponent.vue?vue&type=template&id=3ee59c34"
import script from "./DataTableComponent.vue?vue&type=script&lang=js"
export * from "./DataTableComponent.vue?vue&type=script&lang=js"

import "./DataTableComponent.vue?vue&type=style&index=0&id=3ee59c34&lang=css"
script.render = render

export default script